import axios from 'axios';
import { attachAuthInterceptors } from '@/services/auth';

const AUTH_API_BASE_URL = String(import.meta.env.VITE_AUTH_API_BASE_URL || '').replace(/\/+$/, '');

const accountsClient = axios.create({
  baseURL: AUTH_API_BASE_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Token from sessionStorage on request; refresh ONLY on 401 response.
attachAuthInterceptors(accountsClient);

export async function checkProductAccess(productKey: string): Promise<{ accessible: boolean; productKey: string }> {
  const res = await accountsClient.get('/me/products/check', { params: { productKey } });
  const raw = res.data as
    | { accessible?: unknown; productKey?: unknown; body?: { accessible?: unknown; productKey?: unknown } }
    | null
    | undefined;
  const body = raw?.body && typeof raw.body === 'object' ? raw.body : raw;
  const accessible = body?.accessible;
  const resolvedKey = body?.productKey;

  if (typeof accessible !== 'boolean') throw new Error('Invalid product access response');

  return {
    accessible,
    productKey: typeof resolvedKey === 'string' && resolvedKey.trim() ? resolvedKey : productKey,
  };
}
